import { alpha, createTheme, Theme } from '@mui/material/styles';

export function createWorkspaceTheme(base: Theme) {
  const dark = base.palette.mode === 'dark';
  const accent = dark ? '#86baff' : '#1969b5';
  return createTheme(base, {
    palette: {
      primary: { main: accent },
      background: { default: dark ? '#131c28' : '#f5f7fa', paper: dark ? '#192432' : '#ffffff' },
      text: { primary: dark ? '#e4edf7' : '#203249', secondary: dark ? '#a5b5c7' : '#627287' },
      divider: dark ? '#2c3a4b' : '#e3e9f0',
      action: { hover: alpha(accent, 0.045), selected: alpha(accent, dark ? 0.15 : 0.085) },
    },
    typography: { fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif' },
    shape: { borderRadius: 8 },
    components: {
      MuiButton: {
        defaultProps: { disableElevation: true },
        styleOverrides: { root: { textTransform: 'none', fontWeight: 600, borderRadius: 8 } },
      },
      MuiButtonBase: {
        styleOverrides: { root: { '&.Mui-focusVisible': { outline: `2px solid ${accent}`, outlineOffset: -2 } } },
      },
      MuiIconButton: { styleOverrides: { root: { borderRadius: 8 } } },
      MuiAppBar: { styleOverrides: { root: { boxShadow: 'none', flexShrink: 0 } } },
      MuiAlert: { styleOverrides: { root: { borderRadius: 8 }, message: { fontSize: 13 } } },
      MuiTableCell: { styleOverrides: { root: { borderColor: dark ? '#2c3a4b' : '#e3e9f0' } } },
      MuiDialog: { styleOverrides: { paper: { backgroundImage: 'none', borderRadius: 12 } } },
    },
  });
}
